import { Action } from '../../../actions';
import {
    ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS,
    CHANGE_MINUS_PHRASE_GROUPS_MASS_ACTIONS_RADIO,
    CLOSE_MINUS_PHRASE_GROUPS_MASS_ACTIONS,
    OPEN_MINUS_PHRASE_GROUPS_MASS_ACTIONS
} from '../../../actions/groups-edit/groups-edit-mass-actions';
import { GroupsEditMassActionsState } from '../../../typings/groupsEditState';
import { State } from '../../../typings/state';

import { groupsEditMassActionsInitialState } from './groups-edit-mass-actions';

export const groupsEditMinusPhrasesMassActions = (
    state: GroupsEditMassActionsState = groupsEditMassActionsInitialState,
    action: Action,
    fullState: State
): GroupsEditMassActionsState => {
    switch (action.type) {
        case OPEN_MINUS_PHRASE_GROUPS_MASS_ACTIONS:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    visibleModalActions: {
                        minusPhraseModal: true
                    }
                }
            };
        case ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS:
        case CLOSE_MINUS_PHRASE_GROUPS_MASS_ACTIONS:
            return groupsEditMassActionsInitialState;
        case CHANGE_MINUS_PHRASE_GROUPS_MASS_ACTIONS_RADIO:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        minusPhrasesRadio: action.value
                    }
                }
            };
        default:
            return state;
    }
};
